import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

CollectionItemData.propTypes = {
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  dataField: PropTypes.string,
};

function CollectionItemData({component, dataField, path, ...props}) {
  const item = useSelector((state) => state.Collections.data?.[path]);

  return React
  .createElement(
    component,
    {
      [dataField || "data"]: item,
      path,
      ...props,
    });
}

export default CollectionItemData;
